import classNames from "classnames";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";
import React from "react";

const DSButton = ({
    anchorNewTab, // open link in a new tab
    className,
    children,
    lower,
    forwardedRef,
    selected,
    ...props
}) => {
    const extraProps = {};
    if (props.href && anchorNewTab) {
        extraProps.target = "_blank";
        extraProps.rel = "noopener noreferrer";
    }

    const classes = classNames(
        {
            "text-btnupper": !lower,
            "text-btnlower": lower,
            "ws-button-selected": selected,
        },
        className,
    );

    return (
        <Button className={classes} ref={forwardedRef} {...extraProps} {...props}>
            {children}
        </Button>
    );
};

DSButton.propTypes = {
    anchorNewTab: PropTypes.bool,
    className: PropTypes.string,
    lower: PropTypes.bool,
    selected: PropTypes.bool,
    ...Button.propTypes,
};

DSButton.defaultProps = {
    anchorNewTab: false,
    className: null,
    lower: false,
    selected: false,
    ...Button.defaultProps,
};

const DSDisabledButton = ({ className, ...props }) => (
    <DSButton className={classNames(className, "ws-button-disabled")} {...props} />
);

DSDisabledButton.propTypes = {
    className: PropTypes.string,
};
DSDisabledButton.defaultProps = {
    className: null,
};

const DSDisabledIconButton = ({ className, forwardedRef, ...props }) => (
    <IconButton
        ref={forwardedRef}
        className={classNames(className, "ws-button-disabled")}
        {...props}
    />
);

DSDisabledIconButton.propTypes = {
    className: PropTypes.string,
    ...IconButton.propTypes,
};
DSDisabledIconButton.defaultProps = {
    className: null,
    ...IconButton.defaultProps,
};

const MemoButton = React.memo(DSButton);
const MemoDisabledButton = React.memo(DSDisabledButton);
const MemoDisabledIconButton = React.memo(DSDisabledIconButton);

export const ContainedButton = React.forwardRef((props, ref) => (
    <MemoButton forwardedRef={ref} variant="contained" {...props} />
));
export const OutlinedButton = React.forwardRef((props, ref) => (
    <MemoButton forwardedRef={ref} variant="outlined" {...props} />
));
export const TextButton = React.forwardRef((props, ref) => (
    <MemoButton forwardedRef={ref} variant="text" {...props} />
));

export const DisabledButton = React.forwardRef((props, ref) => (
    <MemoDisabledButton forwardedRef={ref} {...props} />
));

export const DisabledIconButton = React.forwardRef((props, ref) => (
    <MemoDisabledIconButton forwardedRef={ref} {...props} />
));
